import Breadcrumb from "../../Component/Breadcrumb";

function Curriculum() {
  return (
    <>
      <Breadcrumb>Students / Curriculum</Breadcrumb>
      <div className="innersec admission_sec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Curriculum</h1>
            <p>
              The course of study followed in the school is in accordance with
              the syllabus prescribed by the Indian School Certificate
              Examinations, New Delhi, in order to prepare the students for the
              ICSE and ISC Examinations.
            </p>
          </div>
          <div className="row curriculum_row">
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="curriculum_card">
                <h3>Primary School Curriculum</h3>
                <p>(LKG to V)</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="curriculum_card">
                <h3>High School Curriculum</h3>
                <p>(Class VI to X)</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="curriculum_card">
                <h3>ISC - Class XI-XII</h3>
                <p>(Senior Secondary)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Curriculum;
